/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable max-lines-per-function */
import { Card, Col, Row, Space, Typography, Image, Divider, Descriptions } from "antd";
import {
  TrunkDetailList,
  TrunkList,
} from "components/Common/PerlickCommon/PerlickList/PerlickCHOrderList";
import { perlickConstant } from "config/Perlick.Constant";
import {
  IPerlickTrunkDetailList,
  ISingleCHOrderData,
  ITrunkDetailItem,
} from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";
import React, { useEffect, useState } from "react";
import { PerlickTrunkDetailList } from "./PerlickCH.Constant";
import { IColumnProps } from "interfaces/ClientInterface/IEditOrder";
import { PerlickCHTrunkDetailsList } from "api/services/PerlickAPICalls/PerlickCHOrder.api";
import { ICHTrunkDetailsRequest } from "interfaces/APIInterface/IPerlickAPIInterface/ICHOrder";
import { useNavigate, useSearchParams } from "react-router-dom";
import { checkUserSession } from "utils";
import { ROUTES_PATH } from "routes/Routes.Constant";
import TrunkDetailImgCsType1 from "../../../assets/images/trunk/cstype1.jpeg";
import TrunkDetailImgCsType2 from "../../../assets/images/trunk/cstype2.jpeg";
import TrunkDetailImgCsType2A from "../../../assets/images/trunk/cstype2a.jpeg";
import TrunkDetailImgCsType3 from "../../../assets/images/trunk/cstype3.jpeg";
import TrunkDetailImgCsType4 from "../../../assets/images/trunk/cstype4.jpeg";
import TrunkHeadDiagram from "../CHOrder/CHTrunkDetails/CHTrunkHeaderDiagram";
import TrunkHeadDetailsCard from "./CHTrunkDetails/CHTrunkHeadDetailsCard";

import "./CHOrder.scss";

const { Text, Title } = Typography;

type DescriptionItem = {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
};

const PerlickCHTrunkDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const SystemId = searchParams.get("sysId");
  const TrunkNumber = searchParams.get("TrunkNumber");
  const orderNo = searchParams.get("orderNo");

  const columnData = PerlickTrunkDetailList();
  //const [columnsList] = useState(columnData as IColumnProps[]);
  const [columnsList, setColumnsList] = useState<IColumnProps[]>(columnData);
  const [isLoading, setIsLoading] = useState(false);
  const [orderInfoData, setOrderInfoData] = useState<ISingleCHOrderData>();
  const [numberOfRecords, setNumberOfRecords] = useState(0);
  const [numberOfRows, setNumberOfRows] = useState(perlickConstant.DefaultNumberOfRows);
  const [sortingColumn, setSortingColumn] = useState({
    sortByColumnName: "",
    sortType: "",
  });
  const [pageIndex, setPageIndex] = useState(perlickConstant.DefaultPageIndex);
  const [chTrunkDetailData, setchTrunkDetailData] = useState<ITrunkDetailItem[]>([]);

  const cols = [...columnsList];

  const fetchCHTrunkDetails = async () => {
    setIsLoading(true);
    try {
      const request: ICHTrunkDetailsRequest = {
        SystemID: Number(SystemId),
        TrunkNumber: Number(TrunkNumber),
      };
      const response = await PerlickCHTrunkDetailsList(request);
      const data = response?.data?.TrunkDetailsList || [];
      setchTrunkDetailData(data);
      setNumberOfRecords(data.length);
      if (data?.[0]?.restrictiontype) {
        updateSegmentColumnTitle(data[0].restrictiontype);
      }
    } catch {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (checkUserSession()) {
      if (SystemId && TrunkNumber) {
        fetchCHTrunkDetails();
      } else {
        navigate(
          `${ROUTES_PATH.CH_ORDER_DETAILS}?orderId=${orderNo}&salesRepId=${SystemId || "PER011"}`
        );
      }
    } else {
      navigate(ROUTES_PATH.LOGOUT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SystemId, TrunkNumber]);

  const renderSystemTypeImage = () => {
    switch (chTrunkDetailData?.[0]?.systyp) {
      case "1": {
        return TrunkDetailImgCsType1;
      }
      case "2": {
        return TrunkDetailImgCsType2;
      }
      case "A": {
        return TrunkDetailImgCsType2A;
      }
      case "3": {
        return TrunkDetailImgCsType3;
      }
      case "4": {
        return TrunkDetailImgCsType4;
      }
      default: {
        return TrunkDetailImgCsType1;
      }
    }
  };
  const renderTrunkTypeMessage = () => {
    if (chTrunkDetailData?.[0]?.spliceto > 0) {
      return `Splice to trunk housing ${chTrunkDetailData?.[0]?.spliceto}`;
    }
    switch (chTrunkDetailData?.[0]?.trunktype) {
      case "T": {
        return "Trunk Housing Only";
      }
      case "H": {
        return "Heads Only";
      }
      case "D": {
        return "Decade System/Heads only";
      }
      default: {
        return "";
      }
    }
  };

  const items: DescriptionItem[] = [
    {
      key: "1",
      label: "Head Type",
      children: chTrunkDetailData?.[0]?.partno ?? "-",
    },
    {
      key: "2",
      label: "System Type",
      children: chTrunkDetailData?.[0]?.systyp ?? "-",
    },
    {
      key: "3",
      label: "Extra lines to head",
      children: chTrunkDetailData?.[0]?.extra ?? "-",
    },
  ];

  const LineComments = () => {
    if (chTrunkDetailData?.[0]?.linecomments) {
      return (
        <Text>
          <Text strong>Line Comments: </Text> {chTrunkDetailData?.[0]?.linecomments ?? "N/A"}
        </Text>
      );
    }
  };

  const updateSegmentColumnTitle = (restrictionType: string) => {
    let newTitle = "Restriction Segments";
    if (restrictionType === "G") newTitle = "67392-1 Segments";
    else if (restrictionType === "H") newTitle = "71092-1 Segments";

    // Update column titles by creating a new array
    const updatedColumns = columnsList.map((col) =>
      col.dataIndex === "Segments" ? { ...col, title: newTitle } : col
    );

    // Trigger re-render by updating state
    setColumnsList(updatedColumns);
  };

  return (
    <div className="p-15 h-100 century-system-wrapper">
      <Space direction="vertical" size="large" className="d-flex">
        <Row>
          <Col span={24} className="text-center">
            <Title level={3} className="m-0">
              {perlickConstant.CENTURY_SYSTEM_INQUIRY}
            </Title>
            <Text strong>System Id: {chTrunkDetailData?.[0]?.SystemId ?? "N/A"}</Text>
          </Col>
          <Divider className="divider-style" />
          <Col span={24} className="text-center">
            <Title level={4} className="m-0">
              Design Specifications for Trunk Housing {chTrunkDetailData?.[0]?.trunkno ?? "N/A"}
            </Title>
            <Text type="danger" strong>
              {renderTrunkTypeMessage()}
            </Text>
          </Col>
          <Col span={24} className="text-center mt-16">
            <TrunkHeadDiagram trunkDetailData={chTrunkDetailData} />
          </Col>
          <Divider className="divider-style" />
          <Col span={24} className="text-right">
            {LineComments()}
          </Col>
          <Col span={24} className="text-right">
            <Text>
              <Text strong>Billable Ft:</Text> {chTrunkDetailData?.[0]?.BillableFt ?? "N/A"}
            </Text>
          </Col>
          <Divider className="divider-style" />
          <Col span={24}>
            <Row justify="center">
              <Col xs={24} sm={18} md={14} lg={12} xl={10} className="d-flex justify-center">
                <TrunkHeadDetailsCard
                  headNo={chTrunkDetailData?.[0]?.HeadNo}
                  items={items}
                  imageSrc={renderSystemTypeImage()}
                  imageHeight={150} // You can adjust this
                  isLoading={isLoading} // Optional loading prop
                />
              </Col>
            </Row>
          </Col>
          <Divider className="divider-style" />
        </Row>
        <Row>
          <Col span={24} className="gutter-row justify-right align-center">
            <Card bordered={true} className="order-card">
              <Space direction="vertical" size="large" className="d-flex">
                <TrunkDetailList
                  showClass={true}
                  setPageIndex={setPageIndex}
                  setSortSize={setNumberOfRows}
                  NumberOfRecords={numberOfRecords}
                  data={chTrunkDetailData}
                  columns={cols?.filter((item) => !item.hidden)}
                  pagination={false}
                  classSelector={"dashboard-listing-container"}
                  isLoading={isLoading}
                  sortingColumn={sortingColumn}
                  setSortingColumn={setSortingColumn}
                  trunkNumber={chTrunkDetailData?.[0]?.trunkno}
                />
              </Space>
            </Card>
          </Col>
        </Row>
      </Space>
    </div>
  );
};
export default PerlickCHTrunkDetails;
